import { Comment, Avatar, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useState, useEffect, useRef } from 'react';
import { ChatHistory } from '..';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface IndexProps {
  data: ChatHistory[];
  handleScroll: (value: number, behavior: 'smooth' | 'instant' | 'auto') => void;
  handlePredictInfo: (predictionId: number) => void;
}

const Index: React.FC<IndexProps> = ({ data, handleScroll, handlePredictInfo }) => {
  const baseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (data.length > 0 && baseRef.current) {
      setTimeout(() => handleScroll(baseRef.current!.clientHeight, 'smooth'), 300);
    }
  }, [data]);

  return <div ref={baseRef} onLoad={() => console.log("load")}>
    {
      data.map(vo => <History vo={vo} key={vo.id} handlePredictInfo={handlePredictInfo} />)
    }
  </div>
}

const History: React.FC<{ vo: ChatHistory; handlePredictInfo: (predictionId: number) => void; }> = ({ vo, handlePredictInfo }) => {
  const contentStyle = { display: 'flex', flexDirection: 'row', } as React.CSSProperties;
  const avatarStyle = { backgroundColor: '#1890ff' } as React.CSSProperties;
  const avatarContainerStyle = { marginRight: 4 } as React.CSSProperties;
  const contentContainerStyle = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } as React.CSSProperties;

  const from = ['你'].includes(vo.from) ? "你" : vo.from;

  if (from === "你") {
    avatarStyle.backgroundColor = "#f56a00";
    contentStyle.flexDirection = "row-reverse";
    avatarContainerStyle.marginRight = 0;
    avatarContainerStyle.marginLeft = 4;
    contentContainerStyle.alignItems = "flex-end";
  }


  return <Comment
    data-set={vo.id}
    content={
      <div style={contentStyle}>
        <div style={avatarContainerStyle}>
          <Avatar
            size={24}
            style={avatarStyle}>
            {from.substring(0, 1)}
          </Avatar>
        </div>
        <div style={contentContainerStyle}>
          <DiffTime createdAt={vo.createdAt} />
          <p>{vo.content}{vo.predictionId && <a style={{ fontSize: 16 }} onClick={() => handlePredictInfo(vo.predictionId!)}><QuestionCircleOutlined /></a>}</p>
        </div>
      </div>
    }
  />
}

const DiffTime: React.FC<{ createdAt: string }> = ({ createdAt }) => {
  const [diff, setDiff] = useState<string>("");

  useEffect(() => {
    setDiff(getDateTime(createdAt));
    const timer = setInterval(() => {
      setDiff(getDateTime(createdAt));
    }, 1000)
    return () => {
      if (timer) clearInterval(timer);
    }
  }, [])

  function getDateTime(date: string) {
    const day = dayjs().diff(dayjs(date), 'day')
    const hour = dayjs().diff(dayjs(date), 'hour')
    const minute = dayjs().diff(dayjs(date), 'minute')
    const second = dayjs().diff(dayjs(date), 'second')

    if (day >= 1) return `${day}天前`;
    if (hour >= 1) return `${hour}小时前`
    if (minute >= 1) return `${minute}分钟前`
    return `${second || 1}秒前`
  }

  return <Tooltip title={createdAt}>
    <span style={{ lineHeight: '24px', color: '#00000073', fontSize: 12 }}>{diff}</span>
  </Tooltip>
}

export default Index;
